import {Component, Inject, Injectable} from '@angular/core';
import {CorePage} from "../../../core/page/core-page/core.page";
import {ActivatedRoute} from "@angular/router";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'my-contracts-page',
  templateUrl: './my-contracts.page.html',
  styleUrls: ['./my-contracts.page.scss']
})
export class MyContractsPage extends CorePage {

  qrDialog: boolean = false;
  base64: string = '';
  baseUrl: string = '';

  constructor(
    protected override route: ActivatedRoute,
    protected userService: UserApiService,
    @Inject(DOCUMENT) private document: Document
  ) {
    super(route);

  }

  override ngOnInit() {
    super.ngOnInit();
    this.initComponent();
  }

  initComponent() {
    this.baseUrl = this.getBaseUrl();
    this.refreshComponent();
  }

  refreshComponent() {
    this.initialized = true;
  }
  getBaseUrl(): string {
    return this.document.getElementsByTagName('base')[0].href;
  }

  handleQRDialog(){
    if(this.baseUrl){
      this.userService.qrUpload(this.baseUrl+'#/upload').subscribe(value => {
        this.base64 = value.dataBase64;
        this.qrDialog = true;

      })
    }

  }

}
